import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-pinterest-svg',
  templateUrl: './pinterest-svg.component.html',
  styleUrls: ['./pinterest-svg.component.scss']
})
export class PinterestSvgComponent {
  @HostBinding('class') classes = 'market-quest-icon ';
  @Input() size = 24;
  @Input() fillColor = '#1f69ff';

  constructor() {}
}
